
















































import { createComponent, computed } from '@vue/composition-api'

export default createComponent({
  name: 'SafetyModal',
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  setup (props, context) {
    const safetyModalState = computed({
      get: () => props.value,
      set: (value) => context.emit('input', value)
    })

    return {
      safetyModalState
    }
  }
})
